import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import Web3 from 'web3';
import axios from 'axios';

function Tasklist() {
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [analytics, setAnalytics] = useState([]);
    const [tabelLoading, setTableLoading] = useState(false);
    const [profileData, setProfileData] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [assets, setAssets] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [assetId, setAssetId] = useState("");
    const [taskStatus, setTaskStatus] = useState('');
    const web3 = new Web3("https://bsc-dataseed.binance.org/");
    const [updateData, setUpdateData] = useState([]);

    //Update UseState
    const [updateTaskType, setUpdateTaskType] = useState("")
    const [updateTaskButton, setUpdateTaskButton] = useState("");
    const [updateProfileImage, setUpdateProfileIMage] = useState("");
    const [updateAccountLink, setUpdateAccountLink] = useState("");
    const [updateTitle, setUpdateTitle] = useState("");
    const [updateDescription, setUpdateDescription] = useState("");
    const [updateNeed, setUpdateNeed] = useState("");
    const [updateAchive, setUpdateAchive] = useState("");
    const [updateRemain, setUpdateRemain] = useState("");
    const [updateStatus, setUpdateStatus] = useState("");
    const [updateTaskID, setUpdateTaskId] = useState("");

    const updateTaskData = (data) => {
        setUpdateTaskId(data.id);
        setUpdateTaskType(data.task_type)
        setUpdateTaskButton(data.button)
        setUpdateProfileIMage(data.image_url)
        setUpdateAccountLink(data.profile_url)
        setUpdateTitle(data.title)
        setUpdateNeed(data.required)
        setUpdateDescription(data.description)
        setUpdateAchive(data.achived)
        setUpdateRemain(data.reamin)
        setUpdateStatus(data.status)


    }








    useEffect(() => {

        fetchAssets(1);
    }, []);

    const handleProfileDataFetched = (data) => {
        setProfileData(data.USER);
        setMasterData(data.MASTERDATA);
    };


    const fetchAssets = async (page, taskStatus) => {
        try {
            const searchData = {
                status: taskStatus,
                page: page,
            };

            const response = await axios.post(
                `${baseurl}/task-lists`,
                searchData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`,
                    },
                    validateStatus: (status) => status < 500 // Prevent throwing for 4xx
                }
            );

            if (response.status === 429) {
                console.error("Rate limit exceeded. Please try again later.");
                return;
            }

            const depositResult = response.data;
            console.log('Static data', depositResult);

            if (depositResult.status) {
                setAnalytics(depositResult.taskCount);
                setAssets(depositResult.data);
                setPagination(depositResult.pagination);
                setTableLoading(true);
            } else {
                setTableLoading(true); // Optionally show message
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };



    const filterData = (status) => {
        setTableLoading(false)
        setTaskStatus(status);
        fetchAssets('1', status);
    }


    const handlePageChange = async (page) => {

        setTableLoading(false)
        fetchAssets(page);
    }





    const [accountType, setaccountType] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [profileUrl, setProfileUrl] = useState("");
    const [title, setTitle] = useState("");
    const [descripton, setDescription] = useState("");
    const [required, setRequired] = useState("");
    const [accountButton, setAcountButton] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('task_type', accountType);
        formData.append('image_url', imageUrl);
        formData.append('profile_url', profileUrl);
        formData.append('title', title);
        formData.append('description', descripton);
        formData.append('required', required);
        formData.append('button', accountButton);


        try {
            const response = await axios.post(`${baseurl}/addSubscription`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                alert('Task added successfully!');
                // Optionally reset state here
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }
    };



    const handleUpdate = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('task_id', updateTaskID);
        formData.append('task_type', updateTaskType);
        formData.append('image_url', updateProfileImage);
        formData.append('profile_url', updateAccountLink);
        formData.append('title', updateTitle);
        formData.append('description', updateDescription);
        formData.append('required', updateNeed);
        formData.append('achived', updateAchive);
        formData.append('reamin', updateRemain);
        formData.append('status', updateStatus);
        formData.append('button', updateTaskButton);


        try {
            const response = await axios.post(`${baseurl}/updateSubscription`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                toast.success('Task added successfully!');
                fetchAssets(1);

                // Optionally reset state here
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }
    };




    const deleteTaskData = async (deleteId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this task?");

        if (!confirmDelete) {
            return; // Cancel the deletion if the user says No
        }

        const formData = new FormData();
        formData.append('task_id', deleteId);

        try {
            const response = await axios.post(`${baseurl}/task-delete`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                toast.success(response.data.message);
                fetchAssets(1); // Refresh data
            } else {
                console.error('Error:', response.data.message);
                toast.error(response.data.message || "Failed to delete task.");
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }
    };





    return (
        <>
            <Header>
                <Auth onProfileDataFetched={handleProfileDataFetched} />
                <div className="main-content app-content" >
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Task Setting!</h4>

                            </div>
                            <div className="text-end">
                                <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#addAssetModal" >+ Add Task</button>
                            </div>
                        </div>
                        {/* End Page Header */}

                        {/* row */}
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-primary-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">TOTAL TASK</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.total : '0'}

                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline" />
                                </div>
                            </div>


                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-danger-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">CLOSED TASK</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.close : '0'}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline2" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-warning-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">PENDING TASK</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.pending : '0'}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline3" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-success-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE TASK</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.active : '0'}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline3" />
                                </div>
                            </div>
                        </div>


                        {/* row opened */}
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className=" card-header p-0 d-flex justify-content-between mt-3">
                                        <h3 className="card-title mb-1 text-primary">Task List</h3>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-end">
                                            <select onChange={(e) => filterData(e.target.value)}>
                                                <option value={''}>All</option>
                                                <option value={'active'}>Active</option>
                                                <option value={'pending'}>Pending</option>
                                                <option value={'closed'}>Closed</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="table-responsive country-table">
                                        {tabelLoading ? (
                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                                                <thead>
                                                    <tr>
                                                        <th className="wd-lg-25p">Title</th>
                                                        <th className="wd-lg-25p">Channel</th>
                                                        <th className="wd-lg-25p">Task</th>
                                                        <th className="wd-lg-25p">Required</th>
                                                        <th className="wd-lg-25p">Achived</th>
                                                        <th className="wd-lg-25p">Reamined</th>
                                                        <th className="wd-lg-25p">Date Time</th>
                                                        <th className="wd-lg-25p">Status</th>
                                                        <th className="wd-lg-25p">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {assets.length > 0 ? (
                                                        assets.map((depositData, index) => (
                                                            <tr key={index}>
                                                                 <td> {depositData.title || 'N/A'} </td>   
                                                                <td> {depositData.task_type || 'N/A'} </td>
                                                                <td> {depositData.button || 'N/A'} </td>
                                                                <td> {depositData.required || ''} </td>
                                                                <td> {depositData.achived || '0'}</td>
                                                                <td> {depositData.reamin || '0'}</td>
                                                                <td> {depositData.date_time || '0'} </td>
                                                                <td>
                                                                    {depositData && depositData.status
                                                                        ? depositData.status === 'active' ? (
                                                                            <span className="badge bg-success">{depositData.status}</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">{depositData.status} </span>
                                                                        ) : 'N/A'}
                                                                </td>
                                                                <td>
                                                                    <a data-bs-effect="effect-scale" data-bs-toggle="modal" href="#modaldemo9" className="btn btn-sm btn-warning mr-5" >
                                                                        <i className="fa fa-eye"></i>
                                                                    </a>
                                                                    &nbsp;
                                                                    <a data-bs-effect="effect-scale" onClick={() => updateTaskData(depositData)} data-bs-toggle="modal" href="#modaldemo8" className="btn btn-sm btn-primary ml-10" >
                                                                        <i className="fa fa-edit"></i>
                                                                    </a>
                                                                    &nbsp;
                                                                    <a data-bs-effect="effect-scale" onClick={() => deleteTaskData(depositData.id)} className="btn btn-sm btn-danger ml-10 mr-10" >
                                                                        <i className="fa fa-trash"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td>No Data Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div class="d-flex justify-content-center mb-4">
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                    <div class="gridjs-footer">
                                        <div class="gridjs-pagination">
                                            <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                                            <div className="gridjs-pages text-end">
                                                {/* Previous Button */}
                                                <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                                                {/* First Page */}
                                                <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page > 3 && <span>...</span>}

                                                {/* Middle Pages (2 dynamic pages around current) */}
                                                {Array.from({ length: 5 }, (_, i) => {
                                                    const page = pagination.current_page - 2 + i;
                                                    if (page > 1 && page < pagination.last_page) {
                                                        return (
                                                            <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                                                {page}
                                                            </button>
                                                        );
                                                    }
                                                    return null;
                                                })}

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                                                {/* Last Page */}
                                                {pagination.last_page > 1 && (
                                                    <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                                                        onClick={() => handlePageChange(pagination.last_page)}>
                                                        {pagination.last_page}
                                                    </button>
                                                )}

                                                {/* Next Button */}
                                                <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /row */}

                    </div>
                </div>

                <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="addAssetModalLabel">Add Task</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mt-4">
                                        <label className="form-label">Select Account Type</label>
                                        <select className="form-control" onChange={(e) => setaccountType(e.target.value)}>
                                            <option value={'facebook'}> Facebook Page</option>
                                            <option value={'youyube'}>Youtube</option>
                                            <option value={'instagram'}>Instagram</option>
                                            <option value={'telegram'}>Telegram</option>
                                            <option value={'Twitter'}>Twitter</option>
                                            <option value={'Tiktok'}>Tiktok</option>
                                            <option value={'snap chat'}>Snap Chat</option>
                                            <option value={'linkedin'}>Linked In</option>
                                            <option value={'whats app'}>Whats app</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Enter Profile Image Link</label>
                                        <input type="text" className="form-control" name="requiredFromBalance" value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} placeholder="Enter profile image link" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Enter Account Link</label>
                                        <input type="text" className="form-control" name="requiredToBalance" value={profileUrl} onChange={(e) => setProfileUrl(e.target.value)} placeholder="Enter Profile Link" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Enter Title</label>
                                        <input type="text" className="form-control" name="requiredDownline" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter Title" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Enter Description</label>
                                        <input type="text" className="form-control" name="dailyTask" value={descripton} onChange={(e) => setDescription(e.target.value)} placeholder="Enter Description" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Required user</label>
                                        <input type="text" className="form-control" name="dailyProfitPercent" value={required} onChange={(e) => setRequired(e.target.value)} placeholder="Enter user amount" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Enter Button text</label>
                                        <input type="text" className="form-control" name="showProfitPercent" value={accountButton} onChange={(e) => setAcountButton(e.target.value)} placeholder="Enter Button text" defaultValue="0" />
                                    </div>
                                    <div className="col-md-12 mt-4 text-end">
                                        <button type="submit" className="btn btn-success" onClick={handleSubmit}>Submit</button>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="modaldemo8" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="addAssetModalLabel">Update Task</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Account Name</label>
                                        <input type="text" className="form-control" name="requiredFromBalance" value={updateTaskType} onChange={(e) => setUpdateTaskType(e.target.value)} placeholder="Enter profile image link" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Task</label>
                                        <input type="text" className="form-control" name="requiredFromBalance" value={updateTaskButton} onChange={(e) => setUpdateTaskButton(e.target.value)} placeholder="Enter profile image link" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Profile Image Link</label>
                                        <input type="text" className="form-control" name="requiredToBalance" value={updateProfileImage} onChange={(e) => setUpdateProfileIMage(e.target.value)} placeholder="Enter Profile Link" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Account Link</label>
                                        <input type="text" className="form-control" name="requiredDownline" value={updateAccountLink} onChange={(e) => setUpdateAccountLink(e.target.value)} placeholder="Enter Title" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Title</label>
                                        <input type="text" className="form-control" name="dailyTask" value={updateTitle} onChange={(e) => setUpdateTitle(e.target.value)} placeholder="Enter Description" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Description</label>
                                        <input type="text" className="form-control" name="dailyProfitPercent" value={updateDescription} onChange={(e) => setUpdateDescription(e.target.value)} placeholder="Enter user amount" defaultValue="0" />
                                    </div>

                                    <div className="col-md-4 mt-4">
                                        <label className="form-label">Need Amount</label>
                                        <input type="text" className="form-control" name="showProfitPercent" value={updateNeed} onChange={(e) => setUpdateNeed(e.target.value)} placeholder="Enter Button text" defaultValue="0" />
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <label className="form-label">Achive Amount</label>
                                        <input type="text" className="form-control" name="showProfitPercent" value={updateAchive} onChange={(e) => setUpdateAchive(e.target.value)} placeholder="Enter Button text" defaultValue="0" />
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <label className="form-label">Remain Amount</label>
                                        <input type="text" className="form-control" name="showProfitPercent" value={updateRemain} onChange={(e) => setUpdateRemain(e.target.value)} placeholder="Enter Button text" defaultValue="0" />
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <label className="form-label">Status</label>
                                        <select className="form-control" onChange={(e) => setUpdateStatus(e.target.value)} >
                                            <option value={updateStatus}>{updateStatus}</option>
                                            <option value={"active"}>Active</option>
                                            <option value={"pending"}>Pending</option>
                                            <option value={"reject"}>Reject</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 mt-4 text-end">
                                        <button type="submit" className="btn btn-success" onClick={handleUpdate}>Submit</button>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>



                <ToastContainer />
            </Header>


            <Footer />

        </>
    )
}

export default Tasklist